export const getBlurDataURL = (imageUrl) => {
  // For now, return a simple gray placeholder
  // In a real implementation, you might want to:
  // 1. Use a service like plaiceholder.co
  // 2. Generate a proper blurred version of the image
  // 3. Use a CDN that provides image transformations
  return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNlZWVlZWUiLz48L3N2Zz4='
}
